import { makeAutoObservable } from "mobx";
import { SearchObject } from "app/common/Model/SearchObject";
import {
    deleteMedicalSupplyRequestForm,
    getMedicalSupplyRequestFormById,
    pagingMedicalSupplyRequestForm,
    saveMedicalSupplyRequestForm
} from 'app/services/MedicalSupplyRequestFormService';
import { ConceptForm } from "app/common/Model/ConceptForm";
import { checkSearchObject } from "app/common/LocalFunction";
import { toast } from "react-toastify";
import { MedicationRequestForm } from "app/common/Model/MedicationRequestForm";

export default class MedicalSupplyRequestFormStore {
    searchMedicalSupplyRequestForm = new SearchObject();
    pageMedicalSupplyRequestForm = null;
    selectedMedicalSupplyRequestForm = null;
    openFormCreateOrEdit = false;
    openConfirmDeleteMedicalSupplyRequestForm = false;

    constructor() {
        makeAutoObservable(this);
    }


    pagingMedicalSupplyRequestForm = async (searchObj) => {
        let newSearchObj = {...this.searchMedicalSupplyRequestForm, ...searchObj}
        return await pagingMedicalSupplyRequestForm(newSearchObj)
            .then(({ data }) => {
                this.pageMedicalSupplyRequestForm = data;
            })
            .catch((error) => {
                console.error(error);
                toast.error("Lấy dữ liệu có lỗi");
            })
    }

    handleChangeFormSearch = (searchMedicalSupplyRequestForm) => {
        this.searchMedicalSupplyRequestForm = checkSearchObject(this.searchMedicalSupplyRequestForm, searchMedicalSupplyRequestForm);
        this.pagingMedicalSupplyRequestForm();
    }

    handleOpenFormCreateOrEdit = (medicalSupplyRequestFormId) => {
        if (Boolean(medicalSupplyRequestFormId)) {
            getMedicalSupplyRequestFormById(medicalSupplyRequestFormId)
                .then(({ data }) => {
                    this.selectedMedicalSupplyRequestForm = data;
                    this.openFormCreateOrEdit = true;
                })
                .catch((error) => {
                    console.error(error);
                    toast.error("Lấy dữ liệu có lỗi");
                })
        } else {
            this.selectedMedicalSupplyRequestForm = new MedicationRequestForm();
            this.openFormCreateOrEdit = true;
        }
    }

    saveMedicalSupplyRequestForm = async (medicalSupplyRequestForm, { setSubmitting }) => {
        return await saveMedicalSupplyRequestForm(medicalSupplyRequestForm).then(() => {
            this.selectedMedicalSupplyRequestForm = null;
            toast.success("Lưu mẫu đơn thuốc thành công!");
            this.handleClosePopup();
            this.pagingMedicalSupplyRequestForm();
        })
            .catch(error => {
                console.error(error);
                toast.error("Lưu thông tin mẫu đơn thuốc có lỗi");
            })
            .finally(() => setSubmitting(false))
    }

    handleDeleteMedicalSupplyRequestForm = (medicalSupplyRequestForm) => {
        this.selectedMedicalSupplyRequestForm = { id: medicalSupplyRequestForm?.id };
        this.openConfirmDeleteMedicalSupplyRequestForm = true;
    }

    handleConfirmDeleteMedicalSupplyRequestForm = () => deleteMedicalSupplyRequestForm(this?.selectedMedicalSupplyRequestForm?.id)
        .then(() => {
            if (this.searchMedicalSupplyRequestForm.pageIndex > 1 && this.pageMedicalSupplyRequestForm?.content?.length === 1) {
                this.searchMedicalSupplyRequestForm.pageIndex -= 1;
            }
            toast.success("Xóa mẫu đơn thuốc thành công!")
            this.handleClosePopup();
            this.pagingMedicalSupplyRequestForm();
        })
        .catch(err => {
            console.error(err);
            toast.error("Xóa mẫu đơn thuốc có lỗi");
        })

    handleClosePopup = () => {
        this.openFormCreateOrEdit = false;
        this.openConfirmDeleteMedicalSupplyRequestForm = false;
    }

    resetStore = () => {
        this.searchMedicalSupplyRequestForm = new SearchObject();
        this.pageMedicalSupplyRequestForm = null;
        this.selectedMedicalSupplyRequestForm = null;
        this.openFormCreateOrEdit = false;
        this.openConfirmDeleteMedicalSupplyRequestForm = false;
    }

}